export type Primitive = undefined | string | number | boolean | bigint;

type Values = Primitive | Primitive[];

export type Tuple<Value extends Values = Values> = { [key: string]: Value };

export interface MetadataFactory<Value extends Values> {
  getValue(): Tuple<Value> | Promise<Tuple<Value>>;
}

export type MetadataPlugin<Value extends Values = Values> =
  () => MetadataFactory<Value>;

export interface Metadata {
  getMetadata(): Promise<Record<string, Values>>;
}

export function createMetadataPlugin(plugins: MetadataPlugin[]): Metadata {
  const factories = plugins.map((plugin) => plugin());

  async function getMetadata() {
    const tuples: Array<Tuple> = await Promise.all(
      factories.map((factory) => factory.getValue())
    );
    const result = {};

    for (const tuple of tuples) {
      Object.assign(result, tuple);
    }

    return result;
  }

  return {
    getMetadata,
  };
}
